import { container } from "tsyringe";
import { BookingV4ApiRepository } from "@/app/infrastructures/repositories/api/BookingV4ApiRepository";
import ApiService from "@/app/infrastructures/services/ApiService";
import { BookingV4Endpoint } from "@/app/infrastructures/endpoints/booking-v4/BookingV4Endpoint";
import { BookingV4Mapper } from "@/data/persistences/mappers/BookingV4Mapper";
// import { VoucherV4Mapper } from "@/data/persistences/mappers/VoucherV4Mapper";
import { ProductV4Mapper } from "@/data/persistences/mappers/ProductV4Mapper";
import { CommodityV4Mapper } from "@/data/persistences/mappers/CommodityV4Mapper";
import { BookingV4Presenter } from "@/app/ui/presenters/BookingV4Presenter";

// BookingV4Component — DI binding v4 (mengikuti CreateBookingV3Component.ts), tidak mengubah binding V3
export class BookingV4Component {
  public static init() {
    container.register<BookingV4Endpoint>(BookingV4Endpoint, {
      useClass: BookingV4Endpoint
    });
    container.register<BookingV4Mapper>(BookingV4Mapper, {
      useClass: BookingV4Mapper
    });
    /* container.register<VoucherV4Mapper>(VoucherV4Mapper, {
      useClass: VoucherV4Mapper
    }); */
    container.register<ProductV4Mapper>(ProductV4Mapper, {
      useClass: ProductV4Mapper
    });
    container.register<CommodityV4Mapper>(CommodityV4Mapper, {
      useClass: CommodityV4Mapper
    });
    container.register<BookingV4ApiRepository>(BookingV4ApiRepository, {
      useFactory: (d) => {
        return new BookingV4ApiRepository(
          d.resolve(ApiService),
          d.resolve(BookingV4Endpoint),
          d.resolve(BookingV4Mapper),
          // d.resolve(VoucherV4Mapper),
          d.resolve(ProductV4Mapper),
          d.resolve(CommodityV4Mapper)
        );
      }
    });
    container.register<BookingV4Presenter>(BookingV4Presenter, {
      useFactory: (d) => {
        return new BookingV4Presenter(d.resolve(BookingV4ApiRepository));
      }
    });
  }
}
